import clsx from "clsx";

import LoadingSpinner from "~/components/Loaders/LoadingSpinner";

interface LoadingPageProps {
    loadingPercentage?: number;
    fullscreen?: boolean;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ fullscreen = true, loadingPercentage }) => (
    <section className={clsx("mx-auto flex max-w-7xl items-center justify-center", fullscreen ? "h-96" : "")}>
        <div className="flex flex-col items-center gap-4">
            <LoadingSpinner />
            <p className="text-xs font-bold text-gray-400 select-none">
                Lade Sachen...
                {undefined !== loadingPercentage && (
                    <span className="ml-1 text-xs font-medium text-gray-400">{Math.round(loadingPercentage)}%</span>
                )}
            </p>
            {undefined !== loadingPercentage && (
                <>
                    <div className="w-20 overflow-hidden rounded-full bg-gray-200">
                        <div
                            className="bg-primary-500 h-2 rounded-full transition-all duration-200 ease-in-out"
                            style={{ width: `${loadingPercentage}%` }}
                        />
                    </div>
                </>
            )}
        </div>
    </section>
);

export default LoadingPage;
